import { defineStore } from 'pinia';

import { ParamsOpenModal } from '@/types/components';

export const useModalStore = defineStore('modal', () => {
  const isOpen = ref(false);
  const modalKey = ref(''); // 모달 식별자
  const modalTitle = ref(''); // 모달 제목
  const modalProps = ref({}); // 모달 인수

  const openModal = (params: ParamsOpenModal) => {
    const { modalKey: modalKeyNew = '', modalTitle: modalTitleNew = '', props = {} } = params;
    isOpen.value = true;
    modalKey.value = modalKeyNew;
    modalTitle.value = modalTitleNew;
    modalProps.value = props;
  };

  const closeModal = () => {
    isOpen.value = false;
    modalKey.value = '';
    modalTitle.value = '';
    modalProps.value = {};
  };

  return {
    isOpen,
    modalTitle,
    modalKey,
    modalProps,
    openModal,
    closeModal,
  };
});
